import { AdaptiveModal, Button, Icon, Typography } from "@luce/ui";

import { useDeleteAccountContext } from "../delete-account-context";

export function DeleteSucceedModal() {
  const { step, finish } = useDeleteAccountContext();

  const handleOpenChange = (next: boolean) => {
    if (!next) finish();
  };

  return (
    <AdaptiveModal.Root open={step === "deleted"} onOpenChange={handleOpenChange} dialogSize="sm">
      <AdaptiveModal.Header align="center">
        <Icon name="SmileySad" size={32} className="text-luce-brand-primary" />
        <AdaptiveModal.Title>Your account has been deleted</AdaptiveModal.Title>
      </AdaptiveModal.Header>

      <AdaptiveModal.Body>
        <Typography variant="body-md" align="center">
          We are sad to see you go. Your account has been successfully deleted. Thank you for using
          our service. We hope to serve you again in the future.
        </Typography>
      </AdaptiveModal.Body>

      <AdaptiveModal.Footer layout="stacked">
        <Button size="lg" fullWidth label="Return to Homepage" onClick={finish} />
      </AdaptiveModal.Footer>
    </AdaptiveModal.Root>
  );
}
